import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SysSettingPageRoutingModule } from './sys-setting-routing.module';

import { SysSettingPage } from './sys-setting.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SysSettingPageRoutingModule
  ],
  declarations: [SysSettingPage]
})
export class SysSettingPageModule {}
